<template>
  <div
    v-if="showCookieBanner"
    class="position-fixed zi-highest cookie-banner bg-white card rounded border-gray-200 m-1"
  >
    <div class="card-body">
      <p class="font-weight-bold mb-1">{{ translations.title }}</p>
      <p class="text-muted text-sm mb-3">{{ translations.subtitle }}</p>
      <div class="d-flex justify-content-end flex-wrap">
        <button
          ref="consentButtonRequired"
          @click="consentGiven('required')"
          class="btn btn-sm btn-secondary-subtle"
        >
          {{ translations.accept_required }}
        </button>
        <button
          ref="consentButtonAll"
          @click="consentGiven('all')"
          class="btn btn-sm btn-success ml-2"
        >
          {{ translations.accept_all }}
        </button>
        <button
          ref="showDetailsButton"
          @click="setFeaturesFilter('')"
          v-open-modal="'featureTable'"
          class="btn btn-sm btn-primary-link ml-2"
        >
          {{ translations.show_details }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CookieBanner",
  props: {
    translations: {
      type: Object,
      required: true,
    },
    features: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      showCookieBanner: "features/showCookieBanner",
    }),
  },
  mounted() {
    this.setFeatures({ data: this.features, options: { setDefault: true } });
    this.upsertCookieData();
  },
  methods: {
    ...mapActions({
      consentGiven: "features/consentGiven",
      setFeatures: "features/setFeatures",
      upsertCookieData: "features/upsertCookieData",
      setFeaturesFilter: "features/setFeaturesFilter",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.cookie-banner {
  bottom: 0;
  right: 0;

  button {
    @media (max-width: $screen-md-min) {
      &:not(:last-of-type) {
        margin-bottom: $spacer-2;
      }
      /* stylelint-disable-next-line declaration-no-important */
      margin-left: 0 !important;
      width: 100%;
    }
  }
}
</style>
